import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import ThemeToggle from './ThemeToggle';

const Navbar = () => {
  const location = useLocation();
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);

  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);
  const closeNav = () => setIsNavCollapsed(true);

  useEffect(() => {
    // Close nav on route change
    setIsNavCollapsed(true);

    // Smooth scroll for hash links
    const handleHashLinks = () => {
      if (location.hash) {
        const element = document.querySelector(location.hash);
        if (element) {
          const offsetTop = element.offsetTop - 100;
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth',
          });
        }
      }
    };

    handleHashLinks();

    // Active nav on scroll
    const handleScroll = () => {
      const sections = document.querySelectorAll('.bento-item[id]');
      const scrollY = window.pageYOffset;

      sections.forEach((section) => {
        const sectionTop = section.offsetTop - 150;
        const sectionHeight = section.offsetHeight;
        const sectionId = section.getAttribute('id');
        const navLink = document.querySelector(`.nav-link[href="/#${sectionId}"]`);

        if (
          navLink &&
          scrollY > sectionTop &&
          scrollY <= sectionTop + sectionHeight
        ) {
          document.querySelectorAll('.nav-link').forEach((link) => {
            link.style.color = 'rgba(255, 255, 255, 0.6)';
          });
          navLink.style.color = '#ffffff';
        }
      });
    };

    if (location.pathname === '/') {
      window.addEventListener('scroll', handleScroll);
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [location]);

  const handleNavClick = (e, hash) => {
    closeNav();
    if (location.pathname === '/' && hash) {
      e.preventDefault();
      const element = document.querySelector(hash);
      if (element) {
        const offsetTop = element.offsetTop - 100;
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth',
        });
      }
    }
  };

  const isGalleryPage = location.pathname === '/gallery';

  return (
    <nav className="navbar navbar-minimal navbar-expand-lg fixed-top">
      <div className="container-fluid px-4">
        {/* Top bar - always visible with JP, Theme Toggle, and Burger */}
        <div className="navbar-top-bar">
          <Link className="navbar-brand" to="/">
            <span className="brand-logo">
              <span className="brand-brace-left">&#123;</span>
              <span className="brand-text-container">
                <span className="brand-word-first">
                  <span className="brand-letter-static">J</span>
                  <span className="brand-letter-typed" style={{"--delay": "0"}}>a</span>
                  <span className="brand-letter-typed" style={{"--delay": "1"}}>k</span>
                  <span className="brand-letter-typed" style={{"--delay": "2"}}>e</span>
                </span>
                <span className="brand-space"> </span>
                <span className="brand-word-last">
                  <span className="brand-letter-static">P</span>
                  <span className="brand-letter-typed" style={{"--delay": "0"}}>r</span>
                  <span className="brand-letter-typed" style={{"--delay": "1"}}>a</span>
                  <span className="brand-letter-typed" style={{"--delay": "2"}}>h</span>
                  <span className="brand-letter-typed" style={{"--delay": "3"}}>i</span>
                  <span className="brand-letter-typed" style={{"--delay": "4"}}>n</span>
                  <span className="brand-letter-typed" style={{"--delay": "5"}}>o</span>
                  <span className="brand-letter-typed" style={{"--delay": "6"}}>g</span>
                </span>
                <span className="brand-cursor">_</span>
              </span>
              <span className="brand-brace-right">&#125;</span>
            </span>
          </Link>
          
          {/* Theme toggle - visible on mobile between brand and burger */}
          <div className="navbar-theme-toggle-mobile">
            <ThemeToggle />
          </div>
          
          <button
            className="navbar-toggler"
            type="button"
            onClick={handleNavCollapse}
            aria-controls="navbarNav"
            aria-expanded={!isNavCollapsed}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon">☰</span>
          </button>
        </div>
        
        {/* Collapsible menu - expands below the top bar on mobile */}
        <div 
          className={`navbar-collapse ${!isNavCollapsed ? 'show' : ''}`}
          id="navbarNav"
        >
          <ul className="navbar-nav ms-auto gap-3">
            <li className="nav-item">
              <Link
                className="nav-link"
                to="/#about"
                onClick={(e) => handleNavClick(e, '#about')}
              >
                About
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link"
                to="/#experience"
                onClick={(e) => handleNavClick(e, '#experience')}
              >
                Experience
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link"
                to="/#projects"
                onClick={(e) => handleNavClick(e, '#projects')}
              >
                Projects
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link ${isGalleryPage ? 'active' : ''}`}
                to="/gallery"
                onClick={closeNav}
              >
                AI Gallery
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link"
                to="/#contact"
                onClick={(e) => handleNavClick(e, '#contact')}
              >
                Contact
              </Link>
            </li>
            {/* Theme toggle - visible on desktop in nav menu */}
            <li className="nav-item navbar-theme-toggle-desktop">
              <ThemeToggle />
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;